// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitorings-main h2 {
  text-align: center !important;
}
.monitorings-main .table-section {
  margin: 3.125rem 0;
}
.monitorings-main .table-section p {
  font-size: 1.125rem;
  opacity: 0.8;
  margin-bottom: 0.625rem;
}
.monitorings-main .table-section .ant-table {
  margin: 1.875rem 0;
}
.empty {
  height: 18.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.monitorings-main .table-section .Buttons,
.monitorings-main .table-section .Button {
  display: flex;
  justify-content: flex-end;
}
.monitorings-main .table-section .Buttons button {
  height: 4.375rem;
  width: 18.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin: 0 0px;
  background-color: transparent;
  border: none; */
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/monitorings.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;iBAEe;AACjB","sourcesContent":[".monitorings-main h2 {\n  text-align: center !important;\n}\n.monitorings-main .table-section {\n  margin: 3.125rem 0;\n}\n.monitorings-main .table-section p {\n  font-size: 1.125rem;\n  opacity: 0.8;\n  margin-bottom: 0.625rem;\n}\n.monitorings-main .table-section .ant-table {\n  margin: 1.875rem 0;\n}\n.empty {\n  height: 18.75rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.monitorings-main .table-section .Buttons,\n.monitorings-main .table-section .Button {\n  display: flex;\n  justify-content: flex-end;\n}\n.monitorings-main .table-section .Buttons button {\n  height: 4.375rem;\n  width: 18.75rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin: 0 0px;\n  background-color: transparent;\n  border: none; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
